import { EOctaveType } from '@web/entities/measurement/model/enums/octave.enum'

export const fcToFoLimitMap: Record<
  EOctaveType,
  Array<{ freqCentral: number; foLimit: number }>
> = {
  [EOctaveType.THIRD]: [
    { freqCentral: 20000, foLimit: 5000 },
    { freqCentral: 16000, foLimit: 2500 },
    { freqCentral: 8000, foLimit: 1250 },
    { freqCentral: 4000, foLimit: 625 },
    { freqCentral: 2000, foLimit: 312.5 },
    { freqCentral: 1000, foLimit: 156.25 }
  ],

  [EOctaveType.ONE]: [
    { freqCentral: 16000, foLimit: 5000 },
    { freqCentral: 8000, foLimit: 2500 },
    { freqCentral: 4000, foLimit: 1250 },
    { freqCentral: 2000, foLimit: 625 },
    { freqCentral: 1000, foLimit: 312.5 },
    { freqCentral: 500, foLimit: 156.25 }
  ],

  [EOctaveType.TWO]: [
    { freqCentral: 10000, foLimit: 10000 },
    { freqCentral: 2500, foLimit: 2500 },
    { freqCentral: 800, foLimit: 625 },
    { freqCentral: 160, foLimit: 156.25 }
  ]
}
